import React from 'react';
import { Alert } from 'react-bootstrap';

export default function DisclaimerSimulador() {
  return (
    <Alert variant="info" className="mt-3">
      <small>
        Esta simulação é meramente informativa e não constitui proposta comercial.
        Os valores podem variar conforme condições vigentes na data da compra.
      </small>
    </Alert>
  );
}
